import Vue from 'vue'
import BriqIcon from '@/vue/components-global/BriqIcon.vue'
import BriqIconDefs from '@/vue/components-global/BriqIconDefs.vue'
import BriqButton from '@/vue/components-global/BriqButton.vue'
import BriqInput from '@/vue/components-global/BriqInput.vue'
import BriqRequiredAndOptionalMarkers from '@/vue/components-global/BriqRequiredAndOptionalMarkers.vue'
import BriqCheckbox from '@/vue/components-global/BriqCheckbox.vue'
import BriqCheckboxStandalone from '@/vue/components-global/BriqCheckboxStandalone.vue'
import BriqTextarea from '@/vue/components-global/BriqTextarea.vue'
import BriqRadio from '@/vue/components-global/BriqRadio.vue'
import BriqSubmitButton from '@/vue/components-global/BriqSubmitButton.vue'
import BriqMultiselect from '@/vue/components-global/BriqMultiselect.vue'
import BriqTooltip from '@/vue/components-global/BriqTooltip.vue'
import BriqTimeInput from '@/vue/components-global/BriqTimeInput.vue'
import BriqPanel from '@/vue/components-global/BriqPanel.vue'
import BriqSwitch from '@/vue/components-global/BriqSwitch.vue'
import GreyPage from '@/vue/components-global/GreyPage.vue'
import GreyPageWithPanel from '@v/components-global/GreyPageWithPanel.vue'
import BriqLayout from '@/vue/components-global/BriqLayout.vue'
import FetchErrorTransition from '@/vue/components-global/FetchErrorTransition.vue'
import BriqToggleSwitch from '@/vue/components-global/BriqToggleSwitch.vue'
import BriqEnvironment from '@/vue/components-global/BriqEnvironment.vue'
import RefreshApiTokenDialog from '@/vue/components-global/RefreshApiTokenDialog.vue'
import BriqTable from '@/vue/components-global/BriqTable.vue'
import BriqViewAuditTrail from '@/vue/components-global/BriqViewAuditTrail.vue'
import NotificationContainer from '@v/components/NotificationContainer.vue'
import BriqAlert from '@/vue/components-global/BriqAlert.vue'
import BriqDialog from '@/vue/components-global/BriqDialog.vue'
import QuickActionToggleButton from '@/vue/components-global/QuickActionToggleButton.vue'
import BriqRoot from '@/vue/BriqRoot.vue'

// Can be automated with:
// https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
// Tried but didn't work

Vue.component('BriqIcon', BriqIcon)
Vue.component('BriqIconDefs', BriqIconDefs)
Vue.component('BriqButton', BriqButton)
Vue.component('BriqInput', BriqInput)
Vue.component('BriqRequiredAndOptionalMarkers', BriqRequiredAndOptionalMarkers)
Vue.component('BriqCheckbox', BriqCheckbox)
Vue.component('BriqCheckboxStandalone', BriqCheckboxStandalone)
Vue.component('BriqSwitch', BriqSwitch)
Vue.component('BriqToggleSwitch', BriqToggleSwitch)
Vue.component('BriqTextarea', BriqTextarea)
Vue.component('BriqRadio', BriqRadio)
Vue.component('BriqSubmitButton', BriqSubmitButton)
Vue.component('BriqMultiselect', BriqMultiselect)
Vue.component('BriqTooltip', BriqTooltip)
Vue.component('BriqTimeInput', BriqTimeInput)
Vue.component('BriqPanel', BriqPanel)
Vue.component('GreyPage', GreyPage)
Vue.component('GreyPageWithPanel', GreyPageWithPanel)
Vue.component('BriqLayout', BriqLayout)
Vue.component('FetchErrorTransition', FetchErrorTransition)
Vue.component('BriqEnvironment', BriqEnvironment)
Vue.component('RefreshApiTokenDialog', RefreshApiTokenDialog)
Vue.component('BriqTable', BriqTable)
Vue.component('BriqViewAuditTrail', BriqViewAuditTrail)
Vue.component('NotificationContainer', NotificationContainer)
Vue.component('BriqAlert', BriqAlert)
Vue.component('BriqDialog', BriqDialog)
Vue.component('QuickActionToggleButton', QuickActionToggleButton)
Vue.component('BriqRoot', BriqRoot)
